import { Dropdown, Input } from "antd";
import { ArrowUpDown, CircleX, Search } from "lucide-react";
import React from "react";

function ReportSearchSec({
  searchText,
  searchValue,
  setSearchValue,
  setSearchText,
  sortItems,
  sortBy,
  setSortBy,
}) {
  return (
    <div className="flex justify-between mb-3 gap-2 flex-wrap">
      <div className="flex gap-x-[.65rem] gap-y-2 items-center flex-wrap">
        <div>
          <Input
            prefix={<Search size={15} />}
            suffix={
              (searchText || searchValue) && (
                <button
                  type="button"
                  onClick={() => {
                    setSearchText("");
                    setSearchValue("");
                  }}
                  className="flex items-center justify-center text-gray-500 hover:text-gray-700"
                >
                  <CircleX size={15} />
                </button>
              )
            }
            placeholder="Search students..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onPressEnter={(e) => setSearchValue(e.target.value)}
          />
        </div>

        <Dropdown
          menu={{
            // items: sortItems,
            items: sortItems.map((item) => ({
              ...item,
              className:
                sortBy === item.key
                  ? "!bg-orange-50 !text-[#DC6803] font-semibold"
                  : "",
            })),
            selectedKeys: [sortBy],
            onClick: ({ key }) => {
              setSortBy(key);
            },
          }}
          trigger={["click"]}
        >
          <button className="flex gap-x-[6px] items-center border-[1px] border-gray-300 rounded-md px-3 py-[5px] text-[.85rem] text-[#344054]">
            <ArrowUpDown size={14} />
            Sort by
          </button>
        </Dropdown>
      </div>
    </div>
  );
}

export default ReportSearchSec;
